module.exports = __webpack_public_path__ + "static/img/corner.a283c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/corner.png
// module id = ENAZ
// module chunks = 1